import { useEffect, useState } from 'react'
import apiFetch from '@wordpress/api-fetch'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import getImageUrl from './get-image-url'

const site_url = import.meta.env.VITE_SITE_URL

function Association(props) {
  const [post, setPost] = useState(null)
  const [media, setMedia] = useState(null)
  const [terms, setTerms] = useState(null)

  const get_post = async (id) => {
    return apiFetch({ path: `${site_url}/wp-json/wp/v2/posts/${id}` }).then((posts) => {
      return posts
    })
  }

  const get_media = async (id) => {
    return apiFetch({ path: `${site_url}/wp-json/wp/v2/media/${id}` }).then((media) => {
      return media
    })
  }

  const get_terms = async (id) => {
    return apiFetch({ path: `/wp-json/wp/v2/categories/${id}` }).then((terms) => {
      return terms
    })
  }

  useEffect(() => {
    get_post(props.id).then((post) => {
      setPost(post)
      get_terms(post.categories[0]).then((terms) => {
        setTerms(terms)
      })
      if (post.featured_media) {
        get_media(post.featured_media).then((media) => {
          setMedia(media)
        })
      }
    })
  }, [])

  return (
    <>
      <div>
        <a href={post && post.link}>
          {media?.media_details?.sizes?.full?.source_url ? (
            <img
              src={media.media_details?.sizes?.full?.source_url}
              className="lg:aspect-[315/235] aspect-[609/453] w-full"
            />
          ) : (
            <div className="grid place-items-center p-3">
              <img
                src={getImageUrl('kowashiro1.webp')}
                alt=""
                className="w-full aspect-[315/225] h-full object-contain"
              />
            </div>
          )}
        </a>
        <div className="mt-4 flex w-full justify-between items-center">
          <a
            href={terms && terms.link}
            className="terms"
          >
            {terms && terms.name}
          </a>
          <a
            className="date"
            href={post && post.link}
          >
            {post && format(new Date(post.date), 'yyyy.MM.dd')}
          </a>
        </div>
      </div>
      <style jsx>{`
        .terms {
          border: 2px solid #2964b6;
          border-radius: 24px;
          text-align: left;
          font: normal normal normal 18px/34px Noto Sans JP;
          color: #2964b6;
          padding: 0 27px;
        }
        .date {
          font: normal normal 500 20px/48px Noto Sans JP;
          letter-spacing: 1px;
        }
      `}</style>
    </>
  )
}

Association.propTypes = {
  id: PropTypes.string.isRequired,
}

export default Association
